import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import YardCard from "../SubComponents/YardCard";
import i18next from "i18next";
import ReportBuildViewer from "@mnjsplatform/components/lib/common/Reports/ReportBuildViewer";
import { buildReport } from "@mnjsplatform/data/lib/actions/reportActions";

class Yard extends Component {
  constructor(props, context) {
    super(props, context);

    this.state={
      isLoading: true
    };
  }

  componentDidMount() {

    this.setState({isLoading: true});

    this.props.dispatch(this.props.listStatus.execute({}, {withParams: true}))
      .finally(() => this.setState({isLoading: false}));
  }

  onExportToExcelButtonClick = (row, rowIndex) => {
    const reportId = "WEBListVisit";

    this.props.dispatch(buildReport(reportId, this.props.listStatusParams.getRow(0)));
  };

  renderListCards = (row, rowIndex, renderDefault, dataItem) =>{
    return (
      <YardCard dataItem={this.props.listStatus} rowIndex={rowIndex}/>
    );
  };

  renderParams = (h) => {
    return (
      <div className="row">
          {h.fs.map((fi) => {

            const fn = fi.Name;

            if(fn === "ShowOut" || fn === "ShowHistory"){
              return (
                <div className="col-md-2">
                  <div className="field-title" style={{textAlign: "left"}}>
                    &nbsp;
                  </div>
                  <div>
                    <span style={{verticalAlign: "middle"}}>{h.ed(fn)}</span>&nbsp;{h.lbl(fn)}
                  </div>
                </div>)
            }

            return (
                <div className="col-md-2">
                  <div className="field-title" style={{textAlign: "left"}}>
                    {h.lbl(fn)}
                  </div>
                  <div>
                    {h.ed(fn)}
                  </div>
                </div>
              )
          })}
      </div>)
  };

  render() {

    if(this.state.isLoading)
      return (<div>{i18next.t("LoadingLabel")}</div>);

    return (
      <React.Fragment>
        <ReportBuildViewer/>
        <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
          <div className="col-md-9">
            <h1 className="page-title">
              {i18next.t("YardTitle")}
              {this.props.listStatusParams.isInitialized &&
              <button className="btn btn-regular btn-carrier-action -goahead" style={{marginLeft: '25px'}} onClick={this.onExportToExcelButtonClick}>{i18next.t("ExportToExcel")}</button>
              }
            </h1>
          </div>
          <div className="col-md-3" style={{textAlign: "right", paddingRight: "25px"}}>

          </div>
        </div>

        <ComplexParam dataItem={this.props.listStatusParams}
                      readOnly={false}
                      showSearchBar={false}
                      showApplyButton={false}
                      autoApplyParams
                      rootPath="/"
                      parentDataItem={this.props.listStatus}
                      renderParams={this.renderParams} />

        <div className="row">&nbsp;</div>

        <GridView dataItem={this.props.listStatus}
                  renderRow={this.renderListCards}
                  allowPagination
                  activePageSize={6}
                  showHeader={false}
                  flexBox
                  flexBoxWidthPercent={100}
        />
      </React.Fragment>
    );
  }
}

Yard.propTypes = {
  dispatch: PropTypes.func.isRequired
};


Yard.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
  return {
    listStatus: state.yardState.yardListStatusComp,
    listStatusParams: state.yardState.yardListStatusCompParams,
  };
}

export default connect(mapStateToProps)(Yard);